var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPlusBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1602_28974)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 7.33342H8.66675V3.33341C8.66675 3.1566 8.59651 2.98703 8.47149 2.86201C8.34646 2.73699 8.17689 2.66675 8.00008 2.66675C7.82327 2.66675 7.6537 2.73699 7.52868 2.86201C7.40365 2.98703 7.33342 3.1566 7.33342 3.33341V7.33342H3.33341C3.1566 7.33342 2.98703 7.40365 2.86201 7.52868C2.73699 7.6537 2.66675 7.82327 2.66675 8.00008C2.66675 8.17689 2.73699 8.34646 2.86201 8.47149C2.98703 8.59651 3.1566 8.66675 3.33341 8.66675H7.33342V12.6667C7.33342 12.8436 7.40365 13.0131 7.52868 13.1382C7.6537 13.2632 7.82327 13.3334 8.00008 13.3334C8.17689 13.3334 8.34646 13.2632 8.47149 13.1382C8.59651 13.0131 8.66675 12.8436 8.66675 12.6667V8.66675H12.6667C12.8436 8.66675 13.0131 8.59651 13.1382 8.47149C13.2632 8.34646 13.3334 8.17689 13.3334 8.00008C13.3334 7.82327 13.2632 7.6537 13.1382 7.52868C13.0131 7.40365 12.8436 7.33342 12.6667 7.33342Z",
    fill: "#1B1C1E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1602_28974"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlusBlack);
export default __webpack_public_path__ + "static/media/icon_plus_black.47bb5e10adfbe8bf82de9ce3670000dd.svg";
export { ForwardRef as ReactComponent };